import {forwardRef, useRef, useState} from "react";
import BgPattern from "../../../images/Motif.jpg";
import propoIcon from "../../../images/proposIcon.svg";
import resIcon from "../../../images/ResAide.svg";
import paiementIcon from "../../../images/paiementAide.svg";
import securityIcon from "../../../images/secAide.svg";
import {Link} from "react-router-dom";
import {Formik, Form, Field, ErrorMessage} from "formik";
import * as Yup from "yup";
import {useUpdateTechnician} from "../../../hooks/useUpdateUser";
import {Helmet} from "react-helmet";

const PageAide = () => {
  const [searchValue, setSearchValue] = useState("");
  const [highlightedIndex, setHighlightedIndex] = useState(null);
  const bulletRefs = useRef({});
  const {onContactSupport, isLoadingContact} = useUpdateTechnician();

  const validationSchema = Yup.object().shape({
    sujet: Yup.string().required("Le sujet est requis"),
    message: Yup.string().required("Le message est requis"),
  });

  const initialValues = {
    sujet: "",
    message: "",
  };

  const handleSubmit = async (values, {resetForm}) => {
    onContactSupport(
      {subject: values.sujet, content: values.message},
      resetForm
    );

    // Reset form to initial values
    // resetForm();
  };

  const handleSearch = () => {
    const searchText = String(searchValue || "")
      .trim()
      .toLowerCase(); // ✅ Ensure it's a string

    if (!searchText) return; // ✅ Prevent searching empty values

    const elementsArray = Object.values(bulletRefs.current); // Convert refs object to array

    const foundIndex = elementsArray.findIndex((el) =>
      el?.textContent?.toLowerCase().includes(searchText)
    );

    if (foundIndex !== -1) {
      setHighlightedIndex(foundIndex);

      elementsArray[foundIndex]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  const targetRef = useRef(null);

  const scrollToSection = () => {
    targetRef.current?.scrollIntoView({behavior: "smooth"});
  };
  return (
    <>
      <Helmet>
        <title>Centre d'Aide - Votre Application</title>
        <meta
          name="description"
          content="Trouver des réponses aux questions fréquentes dans notre centre d'aide."
        />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <div className="h-full w-full flex flex-col items-center justify-start gap-10 ">
        <div
          className="w-[100vw] min-h-[420px] h-f bg-cover bg-center  flex flex-col justify-center items-center gap-4 "
          style={{backgroundImage: `url('${BgPattern}')`}}
        >
          <div className="text-white font-bold text-xl sm:text-2xl lg:text-3xl  text-center">
            Vous avez une question ou un problème ?
          </div>
          <div className="text-white font-normal text-xl lg:text-2xl   text-center">
            Nous sommes là pour vous guider{" "}
          </div>
          <div className=" flex flex-col justify-center items-center gap-3 sm:gap-5 w-[95%] sm:w-[80%] lg:w-[626px] mt-6">
            <div className="flex items-center gap-2 h-14 w-full bg-white rounded-full p-[2px] overflow-hidden">
              <i className=" !ml-5  fi fi-rr-search flex justify-center items-center"></i>
              <input
                className="border-none flex-grow placeholder:text-[#7E7E7E] placeholder:text-[13px] "
                type="text"
                placeholder="Tapez votre question ici..."
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    // For debugging
                    handleSearch();
                  }
                }}
              />
              <button
                onClick={handleSearch}
                className="bg-[#1A64B9] text-xs hidden lg:text-sm font-medium sm:flex justify-center items-center h-full text-white rounded-full !px-3 sm:!px-5 lg:!px-12 py-2"
              >
                Rechercher
              </button>
            </div>
            <div className="w-full flex items-center justify-start gap-2 flex-wrap">
              <div
                onClick={scrollToSection}
                className="h-8 cursor-pointer flex justify-center items-center !px-4 py-1 text-white text-xs font-semibold rounded-full border border-white"
              >
                Contacter le support
              </div>

              <Link to={"/conditions-generales"}>
                <div className="h-8 flex justify-center items-center !px-4 py-1 text-white text-xs font-semibold rounded-full border border-white">
                  Consulter les CGUs
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className="grid !px-2 sm:!px-5 lg:!px-0 grid-cols-1 lg:grid-cols-2 gap-6  w-full">
          <CategoryBox
            icon={propoIcon}
            title="À propos de Help Clic"
            items={[
              {
                title: "Comment fonctionne l'application ?",
                description:
                  "Télécharger l’application mobile Helpclic et inscrivez-vous gratuitement.",
              },
              {
                title: "Comment s'inscrire en tant que client ?",
                description:
                  "Ouvrez votre sans frais et demandez directement votre intervention.",
              },
              {
                title: "Comment devenir prestataire de services ?",
                description:
                  "Créez votre compte sans aucun abonnement et trouvez rapidement des clients.",
              },
            ]}
            bulletRefs={bulletRefs}
            highlightedIndex={highlightedIndex}
            searchValue={searchValue}
          />
          <CategoryBox
            icon={resIcon}
            title="Réservation de prestations"
            items={[
              {
                title: "Comment réserver un service à domicile ?",
                description:
                  "Entrez directement en contact avec le prestataire de service de votre choix.",
              },
              {
                title:
                  "Est-ce possible de Modifier ou Annuler une réservation ?",
                description:
                  "Oui. Pour une annulation par le client : remboursement de 100 % au moins 6 h avant le rendez-vous, 70 % entre 4 h et moins de 6 h, 50 % entre 2 h et moins de 4 h, et aucun remboursement moins de 2 h avant. Une annulation par le prestataire, ou le refus par le client d'un report demandé par le prestataire, est remboursée à 100 %.",
              },
              {
                title: "",
                description:
                  "Vous pouvez aussi suivre et confirmer votre réservation à tout moment",
              },
            ]}
            bulletRefs={bulletRefs}
            highlightedIndex={highlightedIndex}
            searchValue={searchValue}
          />
          <CategoryBox
            icon={paiementIcon}
            title="Paiements et tarifs"
            items={[
              {
                title: "Quels sont les moyens de paiement acceptés ?",
                description: "Paiement en ligne (CB, Paypal...)",
              },
              {
                title: "Politique de remboursement ?",
                description:
                  "Les remboursements d'annulation suivent les délais indiqués ci-dessus. Après une intervention, une réclamation peut être déposée avant le versement au prestataire, lequel intervient au plus tôt 14 jours après la clôture.",
              },
            ]}
            bulletRefs={bulletRefs}
            highlightedIndex={highlightedIndex}
            searchValue={searchValue}
          />
          <CategoryBox
            icon={securityIcon}
            title="Sécurité et confidentialité"
            items={[
              {
                title: "Vos informations personnelles sont-elles protégées ?",
                description:
                  "Helpclic s’engage fermement et indéfiniment à protéger la confidentialité de toutes les données des utilisateurs, qu’il s’agisse des clients ou des prestataires.",
              },
              {
                title: "Puis-je partager mon e-mail ou mon téléphone dans la messagerie ?",
                description:
                  "Non. Le partage d'une adresse e-mail ou d'un numéro de téléphone est interdit. Le message ou le fichier est immédiatement refusé et supprimé. La première tentative déclenche un avertissement ; toute récidive entraîne le blocage du compte.",
              },
            ]}
            bulletRefs={bulletRefs}
            highlightedIndex={highlightedIndex}
            searchValue={searchValue}
          />
        </div>
        <div className=" !px-2 sm:!px-5 lg:!px-0 flex  flex-col-reverse lg:grid lg:grid-cols-4 gap-6  w-full">
          <div className="w-full h-fit bg-white !py-6 !px-8 flex flex-col gap-7 rounded-lg text-xs">
            <div className="flex flex-col text-[#19295C] text-sm font-bold">
              <span>Chat en direct :</span>
              <span>Disponible de 9h à 17h</span>
              <span>(du Lundi au Vendredi)</span>
            </div>
            <a
              href="mailto:support@help-clic.fr"
              className="flex gap-2 items-center justify-start"
            >
              <span className="text-[#FF6600] text-sm">
                <i className="fi fi-rr-envelope flex items-center"></i>
              </span>
              <span className="text-[#19295C] font-semibold  ">
                support@help-clic.fr
              </span>
            </a>
            <a
              href="tel:+33780904004"
              className="flex gap-2 items-center justify-start"
            >
              <span className="text-[#FF6600] text-sm">
                <i className="fi fi-rr-phone-call flex items-center"></i>
              </span>
              <span className="text-[#19295C] font-semibold  ">
                +33 7 80 90 40 04
              </span>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.google.com/maps/search/?api=1&query=7%20Boulevard%20de%20Stalingrad%2094400%20Vitry-sur-Seine%20France"
              className="flex gap-2 items-center justify-start"
            >
              <span className="text-[#FF6600] text-sm">
                <i className="fi fi-rr-map-marker flex items-center"></i>
              </span>
              <span className="text-[#19295C] font-semibold  ">
                7 Boulevard de Stalingrad 94400 Vitry-sur-Seine - France
              </span>
            </a>
          </div>
          <div
            className="w-full bg-white !py-10 !px-6 col-span-3 flex flex-col gap-7 rounded-lg"
            ref={targetRef}
          >
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({isSubmitting}) => (
                <Form className="flex flex-col gap-6 w-full">
                  <div className="form-group !mb-0 w-full">
                    <label className="text-[#7E7E7E] font-normal text-sm">
                      Sujet
                    </label>
                    <Field
                      type="text"
                      name="sujet"
                      className="w-full form-control border border-[#EEEEEE] !bg-[#F9F9F9]"
                    />
                    <ErrorMessage
                      name="sujet"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                  <div className="form-group !mb-0 w-full">
                    <label className="text-[#7E7E7E] font-normal text-sm">
                      Message
                    </label>
                    <Field
                      as="textarea"
                      name="message"
                      rows={5}
                      className="w-full form-control border border-[#EEEEEE] !bg-[#F9F9F9]"
                    />
                    <ErrorMessage
                      name="message"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                  <div className="w-full flex justify-end">
                    <button
                      type="submit"
                      disabled={isLoadingContact}
                      className="w-[200px] h-[40px] bg-[#1A64B9] text-white flex justify-center items-center rounded-lg disabled:opacity-50"
                    >
                      {isLoadingContact ? "Envoi..." : "Envoyer"}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
            {/* <form className="flex flex-col gap-6 w-full">
            <div className="form-group !mb-0 w-full">
              <label className=" text-[#7E7E7E] font-normal text-sm">
                Sujet
              </label>
              <input
                type="text"
                className="w-full form-control border border-[#EEEEEE] !bg-[#F9F9F9]"
              />
            </div>
            <div className="form-group !mb-0 w-full">
              <label className=" text-[#7E7E7E] font-normal text-sm">
                Message
              </label>
              <textarea
                rows={5}
                type="text"
                className="w-full form-control border border-[#EEEEEE] !bg-[#F9F9F9]"
              />
            </div>
            <div className="w-full flex justify-end">
              <button
                type="submit"
                className="w-[200px] h-[40px] bg-[#1A64B9] text-white flex justify-center items-center rounded-lg"
              >
                Envoyer
              </button>
            </div>
          </form> */}
          </div>
        </div>

        <div className="w-[100vw] bg-[#19295C] !p-4    ">
          <div className="!mx-auto lg:max-w-[73%] lg:min-w-[1010px] lg:!px-0 flex flex-col-reverse gap-2  justify-center lg:flex-row  lg:justify-between  items-center">
            <span className="text-sm text-white font-medium lg:text-left text-center">
              2025 © HelpClic - Tous droits réservés - Conditions générales{" "}
            </span>
            <ul className="social-icons align-bottom ">
              <li>
                <Link to={"https://www.facebook.com/helpclic"}>
                  <i className="fa fa-facebook "></i>
                </Link>
              </li>
              <li>
                <Link to={"https://www.instagram.com/help.clic/"}>
                  <i className="fa fa-instagram"></i>
                </Link>
              </li>
              <li>
                <Link to={"https://www.linkedin.com/company/help-clic/"}>
                  <i className="fa fa-linkedin"></i>
                </Link>
              </li>
              <li>
                <Link
                  to={
                    "https://www.youtube.com/channel/UCFxxjz2b0PA-MVO2Xg1yB7A"
                  }
                >
                  <i className="fa fa-youtube-play" aria-hidden="true"></i>
                </Link>
              </li>
              <li>
                <Link to={"https://www.tiktok.com/@help.clic"}>
                  <i className="fi fi-brands-tik-tok"></i>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageAide;

const CategoryBox = ({
  icon,
  title,
  items,
  bulletRefs,
  highlightedIndex,
  searchValue,
}) => {
  return (
    <div className="bg-white p-6 rounded-lg py-6 px-14 w-full flex flex-col gap-6 justify-start items-start">
      <div className="flex items-center justify-start gap-4">
        <img src={icon} alt="" className="w-[51px] h-auto" />
        <span className="text-[#19295C] font-bold text-lg leading-4">
          {title}
        </span>
      </div>
      {items.map((item, index) => (
        <BulletListItem
          key={index}
          title={item.title}
          description={item.description}
          ref={(el) => {
            if (el) bulletRefs.current[index] = el; // ✅ Assign dynamically
          }}
          highlight={index === highlightedIndex}
          searchValue={searchValue}
        />
      ))}
    </div>
  );
};

const BulletListItem = forwardRef(
  ({title, description, highlight, searchValue}, ref) => {
    const highlightText = (text) => {
      const term = searchValue?.trim();
      if (!term) return text;
      const escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const parts = String(text).split(new RegExp(`(${escapedTerm})`, "gi"));
      return parts.map((part, index) =>
        part.toLocaleLowerCase() === term.toLocaleLowerCase() ? (
          <mark className="bg-yellow-300" key={index}>
            {part}
          </mark>
        ) : (
          part
        )
      );
    };

    return (
      <div ref={ref} className={`flex items-start justify-start gap-[10px] `}>
        <div className="min-w-[10px] w-[10px] mt-[7px] aspect-square rounded-full bg-[#FF6600]"></div>
        <div className="flex flex-col text-[#19295C] text-base">
          <span className="font-semibold">{highlightText(title)}</span>
          <span className="font-normal">{highlightText(description)}</span>
        </div>
      </div>
    );
  }
);

// const BulletListItem = ({title, description}) => {
//   return (
//     <div className="flex items-start justify-start gap-[10px]">
//       <div className="min-w-[10px] w-[10px] mt-[7px] aspect-square rounded-full bg-[#FF6600]"></div>
//       <div className="flex flex-col  text-[#19295C] text-base">
//         <span className="font-semibold">{title}</span>
//         <span className="font-normal"> {description}</span>
//       </div>
//     </div>
//   );
// };
